// @ts-nocheck
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Base Interceptor for client pcs
* Do not edit this file manually
*/
import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CLIENT_CONTEXT_TOKEN_PCS, HTTP_INTERCEPTORS_PCS } from "../tokens";

@Injectable()
export class PcsBaseInterceptor implements HttpInterceptor {
    private readonly httpInterceptors: HttpInterceptor[] = inject(HTTP_INTERCEPTORS_PCS);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_PCS;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Check if this request belongs to this client using HttpContext
        if (!req.context.has(this.clientContextToken)) {
            // This request doesn't belong to this client, pass it through
            return next.handle(req);
        }

        // Apply client-specific interceptors in reverse order
        let handler = next;

        handler = this.httpInterceptors.reduceRight(
            (next, interceptor) => ({
                handle: (request: HttpRequest<any>) => interceptor.intercept(request, next)
            }),
            handler
        );

        return handler.handle(req);
    }
}
